<template>
  <div>
    <div style="margin-top: 20px">
                    <span><i
                        class="fa fa-asterisk text-danger font10 ml-1"
                        aria-hidden="true"></i>协议名称</span>
      <el-input v-model="data_list.protocol_name"></el-input>
    </div>
    <div style="margin-top: 5px">
        <span><i class="fa fa-asterisk text-danger font10 ml-1"
                 aria-hidden="true"></i>外部功能码</span>
      <el-input v-model="data_list.set_no_outside" v-if="Data.radio==='69'"></el-input>
      <el-input v-model="data_list.func_no_outside" v-else></el-input>
    </div>
    <div style="margin-top: 20px">
                    <span><i
                        class="fa fa-asterisk text-danger font10 ml-1"
                        aria-hidden="true"></i>是否分发:</span>
      <el-switch
          v-model="data_list.distribute"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-text="是"
          inactive-text="否"
          :active-value="1"
          :inactive-value="0">
      </el-switch>
      <!--      <el-input v-model="data_list.distrbute"></el-input>-->
    </div>
    <div style="margin-top: 5px">
      <span>控制方法名:</span>
      <el-input v-model="data_list.commd_function"></el-input>
    </div>
    <div style="margin-top: 5px">
        <span><i
            class="fa fa-asterisk text-danger font10 ml-1"
            aria-hidden="true"></i>功能码名称:</span>
      <el-select v-model="func_name" filterable placeholder="请选择"
                 @change="choiceFunc" value-key="name"
                 @focus="query_funcList">
        <el-option
            v-for="item in options"
            :key="item.func_no_inside"
            :label="item.name"
            :value="item">
        </el-option>
      </el-select>
    </div>
    <div style="margin-top: 5px">
        <span>内部功能码:
         <el-link disabled v-if="Data.radio==='69'">{{ data_list.set_no_inside }}</el-link>
         <el-link disabled v-else>{{ data_list.func_no_inside }}</el-link>
        </span>
    </div>
    <div style="margin-top: 5px">
        <span>code值:
            <el-link disabled>{{ data_list.logic_code }}</el-link>
       </span>
    </div>
    <div style="margin-top: 5px">
        <span>数据类型:
          <el-link disabled>{{ data_list.data_type }}</el-link></span>
    </div>
<!--    <div style="margin-top: 5px">-->
<!--        <span>值类型:-->
<!--          <el-link disabled>{{ data_list.data }}</el-link></span>-->
<!--    </div>-->
    <div style="margin-top: 5px"
         v-if="Data.radio==='69'&&func_name!==''&&(data_list.data_type==='Enum'||data_list.data_type==='Bool')">
      <span>控制值字典:</span>
      <el-input v-model="data_list.set_map"></el-input>
    </div>
    <span slot="footer" class="dialog-footer">
                <el-button @click="clearData">取 消</el-button>
                <el-button type="primary" @click="todo_sth">提 交</el-button>
              </span>
  </div>

</template>

<script>

export default {
  name: "new_input",
  props: [
    'Data'
  ],


  data() {
    return {
      data_list: this.$store.state.protocol_data,
      func_name: '',
      options: [],
      set_map: {"map": {"0": "关机", "1": "开机"}, "type": "str"}
    };
  },

  mounted() {
    // console.log(this.Data, this.data_list,'lllll')
    if (this.Data.title === '协议编辑') {
      this.func_name = this.$store.state.protocol_data.name
      this.data_list.set_map = JSON.stringify(this.data_list.set_map)
    }
    if (this.Data.radio === '69' && this.Data.title === '新增协议') {
      this.data_list.distribute = 1
      this.data_list.set_map = '{"map": {"0": "关机", "1": "开机"}, "type": "str"}'
    }
  },
  methods: {
    todo_sth() {
      if (this.Data.title === '协议编辑') {
        this.edit_agreement()
      } else if (this.Data.title === '新增协议') {
        this.add_agreement()
      }
    },
    //编辑协议
    edit_agreement() {
      this.data_list.name = this.func_name
      console.log(this.data_list, 'saf')
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/UpdateObject',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "object_data": this.data_list,
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            message: '操作成功',
            type: 'success',
          });
          this.clearData()
        } else {
          this.$message({
            message: response.data.content,
            type: 'error'
          });
        }
      })
    },
    //新增协议
    add_agreement() {
      console.log(this.data_list, 'saf')
      if (this.Data.radio === '68') {
        if (this.data_list.protocol_name === '' || this.data_list.func_no_outside === null) {
          this.$message({
            message: '请输入协议名称或外部功能码',
            type: 'error'
          });
          return
        }
      } else {
        if (this.data_list.protocol_name === '' || this.data_list.set_no_outside === null) {
          this.$message({
            message: '请输入协议名称或外部功能码',
            type: 'error'
          });
          return
        }
      }
      if (this.func_name === '') {
        this.$message({
          message: '请选择功能码',
          type: 'error'
        });
        return
      }
      this.data_list.name = this.func_name
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/AddNewObject',
        data: {
          "version": "V1.1",
          "timestamp": "0",
          "data": {
            "object_data": this.data_list,
          }
        },
      }).then((response) => {
        if (response.data.result === 200) {
          this.$message({
            message: '录入成功',
            type: 'success',

          });
          this.clearData()
        } else if (response.data.result === 9999) {
          this.$message({
            message: '未知异常',
            type: 'error'
          });
        }
      })

    },
    //选择功能码
    choiceFunc(data) {
      console.log(data, 'dara')
      this.func_name = data.name
      this.data_list.data_type = data.data_type
      this.data_list.data = data.data
      this.data_list.logic_code = data.logic_code
      if (this.Data.radio === '69') {
        this.data_list.set_no_inside = data.func_no_inside
      } else {
        this.data_list.func_no_inside = data.func_no_inside
      }
      // this.$store.commit('get_protocol_data', this.data_list)
    },
    //查询功能码名称
    query_funcList() {
      // var n= this.func_name
      this.$axios({
        method: 'get',
        url: this.IBMS_API + 'IBMS/DeliveryPlatform/QueryFuncList',
        params: {
          "search": '',
          "type": this.Data.radio,
        },
      }).then((response) => {
        console.log(response.data)
        this.options = response.data.content.func_list
      })
    },


    get_function_type(value) {
      console.log(value, 'sss')

      this.$emit('pushData', value)
    },
    clearData() {
      console.log('ss')
      // this.flag = false
      // var obj = [{
      //   name: '',
      //   func_no_outside: '',
      //   func_no_inside: '',
      //   data_type: '',
      //   id: '',
      // }]
      // this.$store.commit('get_protocol_data', obj)
      this.data_list = []
      this.$emit('pushData', false)

      // this.index = 0
      // this.flag = true
    }
  }
}
</script>

<style scoped>
#remove:hover {
  color: bisque;
}

#plus:hover {
  color: bisque;
}
</style>